goog.provide('el8.appchart.dialog.manualLabEntry');

goog.require('el8.appchart.dialog.reports');
goog.require('el8.appchart.mainFeeds.chart');
goog.require('el8.appchart.mainFeeds.reqAct');
goog.require('el8.appchart.cqmRefresh');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.template.appchart.dialog.manualLabEntry');
goog.require('el8.template.appshared.dialog.addDiscreteLabValues');
goog.require('el8.service.tooltip');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.ButtonSet');

//
// Point-of-Care lab entry dialog in the chart
//
// Uses some stripped down code originally from discreteLabFields and docMgr.Filer.
// This is similar to "quick add" type form in docMgr.Filer.
//
// The only code that is shared is the addDiscreteLabValues.labPanelSection template. That's
// the collapsible list of panels
//
el8.appchart.dialog.manualLabEntry = (function() {
    var _panels = [];
    var _form = null;
    var _associatedLabReportId = null;
    var _target = null; // Test to open on show from CDS

    var that = new el8.uiwidget.FormDialog({
        title: 'Point-of-Care Labs',
        height: 630,
        width: 370,
        contentFn: function() {
            return el8.template.appchart.dialog.manualLabEntry.content({
                isStaff: el8.data.currUser.isOfficeStaff()
            });
        }
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        var $content = that.getContentElt(); // wrapper
        var physicianMindreaderOpts = {
            data: function() { return el8.data.practiceUsers.getPhysicianUsers(); },
            formatResult: function(item) { return item.fullName; },
            formatSelected: function(item) { return item.fullName; },
            rowToStringFn: function(item) { return item.fullName; }
        };

        var _datetime_fields =  [
            {
                name: 'customTitle',
                selector: ':input[name="customTitle"]',
                infoText: ''
            },
            {
                name: 'collectionDate',
                selector: ':input[name="collectionDate"]',
                infoText: 'date...',
                datePickerOpts: { maxDate: el8.service.tz.today() }
            },
            {
                name: 'collectionTime',
                selector: ':input[name="collectionTime"]',
                timePickerOpts: {
                    increment: 1
                }
             },
            {
                name: 'resultDate',
                selector: ':input[name="resultDate"]',
                infoText: 'date...',
                datePickerOpts: { maxDate: el8.service.tz.today() }
            },
            {
                name: 'resultTime',
                selector: ':input[name="resultTime"]',
                timePickerOpts: {
                    increment: 1
                }
             },
            {
                name: 'isSignedOff',
                selector: ':input[name="isSignedOff"]'
            },
            {
                name: 'physicianUserName',
                selector: ':input[name="physicianUserName"]',
                infoText: 'reviewer name...',
                height: 16,
                mindreaderOpts: physicianMindreaderOpts,
                newMindreader: true
            }
        ];
        if (el8.data.currUser.isOfficeStaff()) {
          _datetime_fields.push({
              name: 'isUrgent',
              selector: ':input[name="isUrgent"]'
          });
        }

        // FYI: This is a little unusual in that we use the form for the datetime fields and the
        // buttons, but manually update/extract the lab result values
        var form = new el8.uiwidget.Form({
            container: $('.manual-lab-values-form', $content),
            fields: _datetime_fields
        });

        _form = form;

        var verb = el8.data.currUser.isPhysician() ? 'Sign' : 'File';
        form.addButton('file', verb, function(form) { that.save(false); }, true);
        form.addButton('file-and-export', verb + ' & Export to Note', function(form) { that.save(true); }, false);
        form.addButton('discard', 'Discard', function(form) {
            that.hide();
        }, false);

        that.setForm(form);

        // Get and fill the panels (static list)
        $.el8_ajax({
            type: 'GET',
            async: false,
            url:  el8.service.urls.get('pocPanels'),
            success: function(data) {
                if (data && data.panels) {
                    data.panels.sort(function(a, b) {
                        if (a.description === undefined) {
                            return 1;
                        } else if (b.description === undefined) {
                            return -1;
                        } else {
                            return a.description.toLowerCase().localeCompare(b.description.toLowerCase());
                        }
                    });
                    data.panels.forEach(function (panel) {
                        if (panel.tests) {
                            panel.tests.sort(function(a, b) {
                                if (a.name === undefined) {
                                    return 1;
                                } else if (b.name === undefined) {
                                    return -1;
                                } else {
                                    return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
                                }
                            });
                        }
                    });
                    _panels = data.panels;
                } else {
                    _panels = [];
                }
            },
            error_override: function() { that._updatePanelLabValues([]); }
        });
    };

    var super_show = that.show;

    //
    // Can be called with:
    // - nothing
    // - {'target': ... }
    // - {'labReportId: ...'}
    that.show = function(opts) {
        var _opts = opts || {};
        _associatedLabReportId = _opts.labReportId ? _opts.labReportId : null;
        _target = _opts.target ? _opts.target : null;

        super_show.call(that);
        that._updatePanelLabValues(_panels); // reset on show
        this._form.enable();

        var now = el8.service.tz.now();
        _form.setVal('collectionDate', now.asString());
        _form.setVal('collectionTime', now.asTimeString());
        _form.setVal('resultDate', now.asString());
        _form.setVal('resultTime', now.asTimeString());
        _form.setVal('customTitle', 'Point-of-Care Labs');

        if (el8.data.currUser.isPhysician()) {
            _form.setMindreaderItem('physicianUserName', el8.data.currUser.asSoyMap());
        } else {
            var pcpId = el8.ptdata.currPatient.getPrimaryPhysicianUserId();
            if (pcpId) {
                var user = el8.data.practiceUsers.getById(pcpId);
                that._form.setMindreaderItem('physicianUserName', user.asSoyMap());
            }
        }

        if (_target) {
            // that._labtests is a dict keyed by labtestId. Find the labtestcategory_id matching
            // the code to get the collapsible panel section. Silently ignore the no match condition.
            var match = _.find(that._labtests, function(v) { return v.code === _target; });
            if (match) {
                var labtestId = match.labtest_id;
                var input = $("input[data-labtest-id='"+labtestId+"']", that.getContainer());
                var panelstr = "#add-panel-lab-value-" + match.labtestcategory_id + '-section';
                var panel = $(panelstr, that.getContainer());
                if (panel.length) {
                    panel.trigger('el8_expand');
                    input.focusFocus();
                }
            }
        }

        that.adjustHeight();
        that.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        _associatedLabReportId = null;
        super_hide.call(that);
    };

    that._updatePanelLabValues = function(panels) {
        var that = this;

        var $container = $(".manual-lab-values-content");
        $container.html('');

        that._labtests = {}; // maintains a list of labs + values
        that._labtest_values = {}; // maintains a list of lab values entered

        panels.forEach(function (panel, index) {
            var a = el8.template.appshared.dialog.addDiscreteLabValues.labPanelSection({
                labtestcategoryId: panel.labtestcategory_id,
                vendorId: panel.vendor_id,
                description: panel.description,
                tests: panel.tests,
                wider: true
            });
            $container.append(a);

            panel.tests.forEach(function(test) {
                that._labtests[test.labtest_id] = test;
                that._labtests[test.labtest_id]['labtestcategory_id'] = panel.labtestcategory_id;
                that._labtests[test.labtest_id]['vendor_id'] = panel.vendor_id;
            });
        });

        // Some mild validation based on reference ranges if they exist (including Negative/Positive
        // case. Just highlights the value in red, but doesn't prevent save.
        $container.on('keyup', '.lab-value-field-entry',  function(e) {
            var $input = $(e.currentTarget);
            var labtestId = $input.attr('data-labtest-id');

            var isOutOfRange = false;
            if (that._labtests.hasOwnProperty(labtestId)) {
                var value = null;
                var labtestData = that._labtests[labtestId];
                var min = labtestData['ref_min'];
                var max = labtestData['ref_max'];

                if (min.toLowerCase() === 'negative') {
                    var value = $input.val();
                    if (_.contains(['+', '++', '+++', 'pos', 'positive'], value.toLowerCase())) {
                        isOutOfRange = true;
                    }
                } else {
                    var value = parseFloat($input.val());
                    if ((min !== null && min !== '') && value < min) { isOutOfRange = true; }
                    if ((max !== null && max !== '') && value > max) { isOutOfRange = true; }
                }
            }

            if (isOutOfRange) { $input.addClass('el8AttentionText el8Bold'); }
            else { $input.removeClass('el8AttentionText el8Bold'); }
        });

        // Tooltips
        $container.find('.lab-value-field-entry').each(function() {
            var $this = $(this);
            var labtestId = $this.attr('data-labtest-id');

            var msg = 'Ref Range: ';
            if (that._labtests.hasOwnProperty(labtestId)) {
                var labtestData = that._labtests[labtestId];
                var min = labtestData['ref_min'];
                var max = labtestData['ref_max'];

                // Special case for Negative/Positive tests
                if (min === 'Negative') {
                    msg += min;
                }
                else if (min !== '' && min !== null) {
                    if (max !== '' && max !== null) {
                        msg += min + " - " + max;
                    }
                    else {
                        msg += "> " + min;
                    }
                }
                else {
                    if (max !== '' && max !== null) {
                        msg += "< " + max;
                    }
                    else {
                        msg += "Not Specified";
                    }
                }
            }

            if (msg !== 'Ref Range: Not Specified') {
                el8.service.tooltip.create({
                    anchor: $this,
                    text: msg,
                    theme: ['larger', 'dark']
                });
            }
        });

        // Create the collapsible for each panel
        panels.forEach(function (panel, index) {
            var panelSelector = "#add-panel-lab-value-" + panel.labtestcategory_id;

            el8.uiwidget.collapsible({
                container: $(panelSelector+'-section', $container),
                triggerElt: $(panelSelector+'-trigger', $container),
                statusElt: $(panelSelector+'-status', $container),
                expandFn: function() {},
                collapseFn: function() {}
            });

            $(panelSelector+'-trigger', $container).trigger('click');
        });
    };

    that.save = function(exportToNote) {
        var exportToNote = exportToNote || false;

        if (!this._form.isValid()) { return; }

        this._form.disable();

        var map = this._form.getMapped(false, true);

        var collectionDateTime = el8.service.tz.processDateAndTimeInputs(
            _form.getVal('collectionDate'),
            _form.getVal('collectionTime')
        );
        var resultDateTime = el8.service.tz.processDateAndTimeInputs(
            _form.getVal('resultDate'),
            _form.getVal('resultTime')
        );

        if (!collectionDateTime || !resultDateTime) {
            el8.uiwidget.alert('Please enter a valid date and time.');
            that._form.enable();
            return;
        }

        map['collection_datetime'] = el8.service.tz.asServerFormatDateTime(collectionDateTime);
        map['result_datetime'] = el8.service.tz.asServerFormatDateTime(resultDateTime);

        // Get the result values
        var $content = $('.manual-lab-values-content');
        var $labValueFieldInputs = $('.lab-value-field-entry', $content);

        $labValueFieldInputs.each( function($index, input) {
            var $input = $(input);
            var val = $.trim($input.val());
            if (val === '') { return; }

            // lookup labtest id, then use that to lookup local cache of lab attributes
            var labtestId = $input.attr('data-labtest-id');

            if (that._labtests.hasOwnProperty(labtestId)) {
                var labtestData = that._labtests[labtestId];
                var obj = $.extend({}, labtestData);
                obj['result_id'] = null;
                obj['value'] = val;

                if (!map['lab_values']) { map['lab_values'] = []; }
                map['lab_values'].push(obj);
            }
        });

        if (!map['lab_values']) {
            el8.uiwidget.alert('Please enter a result.');
            that._form.enable();
            return;
        }

        // Additional stuff for post
        map['associated_lab_report_id'] = _associatedLabReportId;

        // Validate physicianUserName
        var reviewUserItem = this._form.getMindreaderItem('physicianUserName');
        if (el8.data.currUser.isOfficeStaff()) {
            if (!el8.data.practiceUsers.nameExists(reviewUserItem.fullName, true)) { // Only physicians
                that._form.enable();
                var mr = that._form.getMindreader('physicianUserName');
                mr.setInputVal(null); // Clear field
                el8.uiwidget.alert('Reviewer is not recognized. Please select from the auto-suggest list.',
                                   true,
                                   // Re-focus
                                   function() { $(':input[name="physicianUserName"]', that._form.getContainer()).focusFocus(); });
                return;
            }
        }
        map['review_user_id'] = reviewUserItem ? reviewUserItem.id : null;

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('pocPanels'),
            data: JSON.stringify(map),
            success: function(data) {

                if (exportToNote) {
                    // If there is a draft note, export to relevant sections: “Data” for 1-col,
                    // 2-col, and pre-op notes, "O" for SOAP note, and big text box for simple note
                    //
                    // If there is not a draft note, create a new note using the user default and
                    // export to relevant sections.
                    //
                    // File and Export can occur regardless whether file on behalf of reviewer is
                    // checked on or off and is available for staff and providers
                    var report = el8.ptdata.fetchById(data.id);

                    _.each(report.getResultGrids(), function(grid) {
                        _.each(grid.getResultsByCategory(), function(result) { // results
                            _.each(result.rows, function(row) { // rows
                                el8.appchart.mgr.notes.addReference({
                                    item: report.getResultRow(row.getId())
                                });
                            });
                        });
                    });
                }

                var _cb = function (item) {
                    el8.appchart.dialog.reports.refresh('lab', true, true); // async feed.refresh()
                    el8.appchart.mainFeeds.chart.update();
                    el8.appchart.mainFeeds.reqAct.update();
                    el8.appchart.cqmRefresh.forceRefresh(false);
                };

                if (_associatedLabReportId) {
                    el8.ptdata.refreshDocById(_associatedLabReportId, {
                        async: true,
                        callbackFn: _cb
                    });
                } else {
                    _cb();
                }

                that.hide();
            },
            error: function() {
                that._form.enable();
            }
        });
    };

    return that;
})();
